const STORAGE_KEY = 'owner-pending-redirect'
const TTL_MS = 10 * 60 * 1000 // 10 minutes

interface StoredRedirect {
  path: string
  expiresAt: number
}

const write = (path: string): void => {
  const value: StoredRedirect = { expiresAt: Date.now() + TTL_MS, path }
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value))
}

const read = (): string | null => {
  const raw = sessionStorage.getItem(STORAGE_KEY)
  if (!raw) return null

  const parsed: StoredRedirect = JSON.parse(raw)
  if (Date.now() > parsed.expiresAt) {
    sessionStorage.removeItem(STORAGE_KEY)
    return null
  }

  return parsed.path
}

const clear = (): void => {
  sessionStorage.removeItem(STORAGE_KEY)
}

export const setPendingRedirect = (path: string): void => {
  try {
    write(path)
  } catch {
    // sessionStorage may be unavailable (private browsing, etc.)
  }
}

export const peekPendingRedirect = (): string | null => {
  try {
    return read()
  } catch {
    return null
  }
}

export const popPendingRedirect = (): string | null => {
  try {
    const path = read()
    clear()
    return path
  } catch {
    return null
  }
}

export const clearPendingRedirect = (): void => {
  try {
    clear()
  } catch {
    // noop
  }
}
